import ApiPurchaseOrderAdjustment from "../../../../../../shared/model/ApiPurchaseOrderAdjustment";
import ApiPurchaseOrder from "../../../../../../shared/model/ApiPurchaseOrder";
import { useStaticData } from "../../../../../../context/staticData";
import React from "react";
import { getFormattedCurrency } from "../../../../../../shared/utils";
import PaymentDetails from "../paymentDetail";
import { useCopies } from "../../../../../../shared/hooks/useCopies";
import Icon from "assets/icons";
import { getDateTimeToDisplay, getPurchaseOrderAdjustmentItemDescription } from "../../util";
import { orderBy } from "lodash";
import { Menu, MenuButton, MenuItem, MenuPopover } from "@reach/menu-button";
import { positionRight } from "@reach/popover";

export default function PurchaseOrderAdjustments(props: {
  purchaseOrderAdjustments?: Array<ApiPurchaseOrderAdjustment>;
  purchaseOrder: ApiPurchaseOrder;
}) {
  const copies = useCopies();
  const { inventoryType, purchaseOrderStatus } = useStaticData();

  if (!props.purchaseOrderAdjustments || props.purchaseOrderAdjustments?.length === 0) {
    return null;
  }

  return (
    <React.Fragment>
      <div className="adjustmentsPopupWrapper">
        <Menu>
          <MenuButton>
            <Icon.Add />
            {copies.get("purchase.order.adjustments", { 0: props.purchaseOrderAdjustments.length })}
          </MenuButton>
          <MenuPopover position={positionRight} className="slide-down adjustmentsPopup">
            <div className="adjustmentsPopup--container">
              <div className="adjustmentsPopup--items">
                <MenuItem onSelect={() => {}}>
                  <div className="adjustmentsPopup--table">
                    <table>
                      <thead>
                        <tr>
                          <th>{copies.get("date")}</th>
                          <th>{copies.get("details")}</th>
                          <th>{copies.get("refund")}</th>
                          <th>{copies.get("payment.method")}</th>
                          <th>{copies.get("status")}</th>
                        </tr>
                      </thead>
                      <tbody>
                        {orderBy(props.purchaseOrderAdjustments, "createdDate.dateTime", "desc").map(item => {
                          return (
                            <React.Fragment key={item.id}>
                              {item.purchaseOrderLineAdjustments.length === 0 ? (
                                <tr>
                                  <td>{getDateTimeToDisplay(item.createdDate)}</td>
                                  <td>{copies.get("refund")}</td>
                                  <td>{getFormattedCurrency(item.amount)}</td>
                                  <td>
                                    <PaymentDetails transaction={item.transaction} />
                                  </td>
                                  <td>{purchaseOrderStatus[item.purchaseOrderStatus]}</td>
                                </tr>
                              ) : (
                                <React.Fragment>
                                  {orderBy(item.purchaseOrderLineAdjustments, "createdDate.dateTime", "desc").map(
                                    (lineAdj, index) => {
                                      const dateTime = getDateTimeToDisplay(lineAdj.createdDate);
                                      return (
                                        <tr key={index}>
                                          <td rowSpan={item.purchaseOrderLineAdjustments.length}>{dateTime}</td>
                                          <td>
                                            {getPurchaseOrderAdjustmentItemDescription(
                                              lineAdj.quantity,
                                              inventoryType[lineAdj.lineType],
                                              lineAdj.purchaseOrderlineAdjustmentType,
                                              copies
                                            )}
                                          </td>
                                          {index === 0 && (
                                            <React.Fragment>
                                              <td rowSpan={item.purchaseOrderLineAdjustments.length}>
                                                {getFormattedCurrency(item.amount)}
                                              </td>
                                              <td rowSpan={item.purchaseOrderLineAdjustments.length}>
                                                <PaymentDetails transaction={item.transaction} />
                                              </td>
                                              <td rowSpan={item.purchaseOrderLineAdjustments.length}>
                                                {purchaseOrderStatus[item.purchaseOrderStatus]}
                                              </td>
                                            </React.Fragment>
                                          )}
                                        </tr>
                                      );
                                    }
                                  )}
                                </React.Fragment>
                              )}
                            </React.Fragment>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                </MenuItem>
              </div>
            </div>
          </MenuPopover>
        </Menu>
      </div>
    </React.Fragment>
  );
}
